import { Pipe, PipeTransform } from "@angular/core";

export interface SplitResult {
    visible: string[];
    hiddenCount: number;
}

/**
 * Splits a string array into the items to render and the count truncated off the end.
 */
@Pipe({ name: "splitter", standalone: true, pure: true })
export class SplitterPipe implements PipeTransform {
    /**
     * @param items the full list of items
     * @param maxVisible the maximum number of items to keep in `visible`
     */
    transform(items: string[], maxVisible: number): SplitResult {
        return {
            visible: items.slice(0, maxVisible),
            hiddenCount: Math.max(0, items.length - maxVisible)
        };
    }
}
